export { TagAlt as default } from './TagAlt';
